/* Notorious Hospitality: ordering page for professionals (/horeca).
   Range filters for every visitor: All products, Super Juice, Mixers, Garnish. A link such as /horeca#mixers
   opens that filter (the older #nh-line-mixers style links still work).
   For verified venues it keeps the Shopify cart in sync with the quantity steppers, shows the order drawer,
   and applies the delivery rules for the venue's postcode before checkout: free route delivery in Oslo from 2,000 kr and in
   Akershus from 4,000 kr excluding MVA; smaller orders there, and every order in the rest of Norway, go by Posten,
   no minimum, priced by weight at checkout (method "Posten").
   Free pickup in Oslo is open to every venue in Norway with no minimum; the choice is saved on the cart
   as the attribute "Delivery choice", so it shows on the order.
   Venues abroad (customer tag venue-abroad): Posten priced by weight at checkout, card payment, no Super Juice.
   Their prices come without MVA through the automatic discount "Export price, without Norwegian MVA",
   so their cart totals are already net, in the cart currency that Shopify converts to.
   Store prices include 15% MVA, so amounts excluding MVA in Norway are total / 1.15.
   Only verified venues get the logged-in view. A customer who signs in through the page (?signin=1) without a
   verified account is signed out again; nh-gate brings them back here with ?unverified=1, which shows the notice.
   Verified venues pick a Thursday (order by Wednesday 18:00, Oslo time, for the next day) and a repeat;
   on a public holiday, Christmas Eve or New Year's Eve the delivery moves a day earlier, with the deadline 18:00 the day before;
   both are saved on the cart as the attributes "Delivery date" (YYYY-MM-DD) and "Repeat".
   Texts come from the page data (D.t, snippet nh-horeca-js-text) in English or Norwegian; numbers and dates follow D.lang.
   Delivery method names stay as Shopify shows them at checkout ("Delivery to your venue on Thursday, Oslo",
   "Pickup at our kitchen (you collect)", "Posten").
   Venues in Norway get two buttons:
   "Send bestilling" (data-send) sends the order straight to us through The Barback App server
   (/apps/barback/send-order): delivered on the Thursday route in Oslo and Akershus from the minimum, or sent with
   Posten elsewhere in Norway, invoiced on 14 days net, with no checkout page. Under the route minimum it first opens a
   short step showing how much is missing: top up, or pay now by card instead.
   "Betal nå med kort" (data-checkout) goes to the normal checkout: card, free pickup in Oslo or Posten.
   The same script runs the order form (section nh-order): its rows are .nh-card elements with the same steppers, a row
   total ([data-row-total], from data-price-ex) and an order summary that is always open (#nh-drawer with data-static). */
(function () {
  'use strict';

  var dataEl = document.getElementById('nh-horeca-data');
  if (!dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var products = D.products || {};
  var approved = D.state === 'approved';
  var T = D.t || {};
  var NB = D.lang === 'nb';
  var LOC = NB ? 'nb-NO' : 'en-GB';
  // A text from the page data, with {placeholders} filled in.
  function tr(key, vars) {
    var str = T[key] != null ? String(T[key]) : key;
    if (vars) Object.keys(vars).forEach(function (k) { str = str.split('{' + k + '}').join(vars[k]); });
    return str;
  }

  // Sign-in from this page without a verified account: sign out again, then show why.
  var params;
  try { params = new URLSearchParams(location.search); } catch (e) { params = null; }
  if (params && params.has('signin') && D.unverified && D.logoutUrl) {
    try { sessionStorage.setItem('nh-unverified', (NB ? '/nb' : '') + '/pages/horeca'); } catch (e) {}
    location.replace(D.logoutUrl);
    return;
  }
  if (params && (params.has('signin') || params.has('unverified'))) {
    var showNotice = params.has('unverified');
    params.delete('signin');
    params.delete('unverified');
    var qs = params.toString();
    if (history.replaceState) history.replaceState(history.state, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
    if (showNotice) {
      var un = document.querySelector('[data-unverified-notice]');
      if (un) un.hidden = false;
    }
  }
  var abroad = !!D.abroad;
  var cart = null;

  var num2 = new Intl.NumberFormat(LOC, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  var num0 = new Intl.NumberFormat(LOC, { maximumFractionDigits: 0 });
  function curCode() { return (cart && cart.currency) || D.currency || 'NOK'; }
  function unit() { var c = curCode(); return c === 'NOK' ? ' kr' : ' ' + c; }
  function kr(cents) { return num2.format(Math.round(cents) / 100) + unit(); }
  function krWhole(cents) { return num0.format(Math.round(cents) / 100) + unit(); }
  function exOf(incCents) { return Math.round(incCents / 1.15); }

  var ZONES = {
    oslo: { key: 'oslo', label: tr('zoneOslo'), minEx: 200000, method: 'Delivery to your venue on Thursday, Oslo' },
    akershus: { key: 'akershus', label: tr('zoneAkershus'), minEx: 400000, method: 'Delivery to your venue on Thursday, Oslo region (Akershus)' },
    posten: { key: 'posten', label: 'Rest of Norway', minEx: 0, method: 'Posten' },
    abroad: { key: 'abroad', label: 'Outside Norway', minEx: 0, method: 'Posten' }
  };
  // Oslo: 0001 to 1299. Akershus: Baerum, Asker, Follo, Romerike, Nes and Vestby postcodes, plus the former Royken and Hurum (3430 to 3499).
  function zoneFor(zip) {
    var digits = String(zip || '').replace(/\D/g, '');
    if (!digits) return null;
    var z = parseInt(digits, 10);
    if (z >= 1 && z <= 1299) return ZONES.oslo;
    if ((z >= 1300 && z <= 1499) || (z >= 1540 && z <= 1559) || (z >= 1900 && z <= 2099) ||
        (z >= 2150 && z <= 2170) || (z >= 3430 && z <= 3499)) return ZONES.akershus;
    return ZONES.posten;
  }
  var zone = abroad ? ZONES.abroad : zoneFor(D.zip);

  var PICKUP = { method: 'Pickup at our kitchen (you collect)' };
  var MODE_KEY = 'Delivery choice';
  var MODE_LABEL = { delivery: 'Delivery to venue', pickup: 'Pickup in Oslo' };
  var mode = 'delivery';

  var live = document.querySelector('[data-live]');
  function say(msg) { if (live) { live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 30); } }

  /* ---------- Range filters (every visitor) ---------- */
  var shop = document.querySelector('[data-shop]');
  var FILTERS = ['all', 'super-juice', 'mixers', 'garnish'];
  var HASH_FILTER = {
    'all-products': 'all', 'super-juice': 'super-juice', 'mixers': 'mixers', 'garnish': 'garnish',
    'nh-line-super-juice': 'super-juice', 'nh-line-mixers': 'mixers', 'nh-line-garnish': 'garnish'
  };
  function setFilter(f) {
    if (!shop || FILTERS.indexOf(f) < 0) return;
    var r = document.getElementById('nh-filter-' + f);
    if (r) r.checked = true;
    shop.setAttribute('data-filter', f);
  }
  if (shop) {
    var checkedFilter = shop.querySelector('input[name="nh-filter"]:checked');
    if (checkedFilter) shop.setAttribute('data-filter', checkedFilter.value);
    shop.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'nh-filter') setFilter(e.target.value);
    });
  }
  function hidden(el) { return !el.offsetParent && getComputedStyle(el).position !== 'fixed'; }
  function openFromHash(smooth) {
    var id = '';
    try { id = decodeURIComponent(location.hash.slice(1)); } catch (e) { return; }
    if (!id) return;
    var target = null;
    if (HASH_FILTER[id]) {
      setFilter(HASH_FILTER[id]);
      target = document.getElementById('nh-range');
    } else {
      var el = document.getElementById(id);
      if (el && el.classList.contains('nh-card') && hidden(el)) { setFilter('all'); target = el; }
    }
    if (target) target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
  }
  window.addEventListener('hashchange', function () { openFromHash(true); });
  openFromHash(false);

  // Smooth in-page links for every visitor. Filter links (#mixers) pick the filter and go to the range.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    var hash = id;
    if (HASH_FILTER[id]) { setFilter(HASH_FILTER[id]); id = 'nh-range'; }
    var el = id && document.getElementById(id);
    if (!el) return;
    e.preventDefault();
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', '#' + hash);
  });

  // Mark the visitor's delivery zone on the delivery cards.
  if (zone) {
    var zc = document.querySelector('[data-zone-card="' + zone.key + '"]');
    if (zc) zc.classList.add('is-yours');
  }

  if (!approved) return;

  /* ---------- Ordering (verified venues only) ---------- */
  var pending = {};      // variantId -> desired quantity not yet sent
  var timer = null;
  var busy = false;

  var cards = Array.prototype.slice.call(document.querySelectorAll('.nh-card[data-variant]')).filter(function (c) { return c.querySelector('[data-qty]'); });
  var countEls = document.querySelectorAll('[data-cart-count]');
  var drawer = document.getElementById('nh-drawer');
  var linesEl = drawer && drawer.querySelector('[data-lines]');
  var zoneBox = drawer && drawer.querySelector('[data-zone-box]');
  var sumEl = drawer && drawer.querySelector('[data-sum]');
  var checkoutBtn = drawer && drawer.querySelector('[data-checkout]');
  var sendBtn = drawer && drawer.querySelector('[data-send]');
  var tipEl = drawer && drawer.querySelector('[data-checkout-tip]');
  var noteEl = drawer && drawer.querySelector('[data-note]');
  var orderbar = document.querySelector('[data-orderbar]');
  var orderbarText = document.querySelector('[data-orderbar-text]');
  var zoneLine = document.querySelector('[data-zone-line]');
  var modeEl = drawer && drawer.querySelector('[data-mode]');
  var whenEl = drawer && drawer.querySelector('[data-when]');
  var dateSel = whenEl && whenEl.querySelector('[data-when-date]');
  var repeatSel = whenEl && whenEl.querySelector('[data-when-repeat]');
  var whenLabel = whenEl && whenEl.querySelector('[data-when-label]');
  var whenHelp = whenEl && whenEl.querySelector('[data-when-help]');

  // Cart requests go through the language prefix (/nb on Norwegian pages), so the cart and checkout keep the page language.
  var ROOT = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');
  function api(url, body) {
    return fetch(ROOT + url, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      if (!r.ok) return r.json().catch(function () { return {}; }).then(function (j) {
        throw new Error(j.description || j.message || ('Request failed (' + r.status + ')'));
      });
      return r.json();
    });
  }

  function norwayOnly(variantId) { var p = products[String(variantId)]; return !!(p && p.norwayOnly); }

  function qtyInCart(variantId) {
    if (!cart) return 0;
    var q = 0;
    cart.items.forEach(function (it) { if (String(it.variant_id) === String(variantId)) q += it.quantity; });
    return q;
  }

  // Venues abroad: Super Juice is sold in Norway only.
  function blockedItems() {
    if (!abroad || !cart) return [];
    return cart.items.filter(function (it) { return norwayOnly(it.variant_id); });
  }

  // Venues abroad: true when the export discount took the MVA off every line.
  function exportApplied() {
    if (!abroad || !cart || !cart.items.length) return true;
    return cart.items.every(function (it) { return it.final_line_price < it.original_line_price; });
  }

  // Order total without MVA: for venues abroad the cart is already net (export discount), in Norway it is total / 1.15.
  function netTotal() {
    if (!cart) return 0;
    return abroad ? cart.total_price : exOf(cart.total_price);
  }

  function zoneStatus() {
    var ex = netTotal();
    if (abroad) { var b = blockedItems(); return { ok: !b.length, ex: ex, short: 0, blocked: b.length }; }
    if (mode === 'pickup' || !zone) return { ok: true, ex: ex, short: 0 };
    // Below the route minimum (Oslo, Akershus) the order goes by Posten instead, priced by weight at checkout.
    if (zone.minEx && ex < zone.minEx) return { ok: true, ex: ex, short: zone.minEx - ex, posten: true };
    return { ok: true, ex: ex, short: 0 };
  }

  /* Card steppers */
  function setCard(card, q) {
    var input = card.querySelector('[data-qty]');
    if (input && document.activeElement !== input) input.value = q;
    card.classList.toggle('is-in-order', q > 0);
    var rowTotal = card.querySelector('[data-row-total]');
    if (rowTotal) rowTotal.textContent = q > 0 ? kr(q * (parseInt(card.getAttribute('data-price-ex'), 10) || 0)) : '';
  }

  function want(variantId, q) {
    if (abroad && norwayOnly(variantId)) return;
    q = Math.max(0, Math.min(999, parseInt(q, 10) || 0));
    pending[variantId] = q;
    cards.forEach(function (c) { if (c.getAttribute('data-variant') === String(variantId)) setCard(c, q); });
    clearTimeout(timer);
    timer = setTimeout(flush, 380);
  }

  function flush() {
    if (busy) { timer = setTimeout(flush, 250); return; }
    var updates = pending;
    pending = {};
    if (!Object.keys(updates).length) return;
    busy = true;
    api('/cart/update.js', { updates: updates })
      .then(function (c) { cart = c; busy = false; render(); ensureWhen(); say(tr('orderUpdated')); })
      .catch(function (err) { busy = false; say(tr('updateFailed') + err.message); load(); });
  }

  cards.forEach(function (card) {
    var v = card.getAttribute('data-variant');
    var input = card.querySelector('[data-qty]');
    var inc = card.querySelector('[data-inc]');
    var dec = card.querySelector('[data-dec]');
    function current() { return pending[v] != null ? pending[v] : (parseInt(input.value, 10) || 0); }
    if (inc) inc.addEventListener('click', function () { want(v, current() + 1); });
    if (dec) dec.addEventListener('click', function () { want(v, current() - 1); });
    input.addEventListener('change', function () { want(v, input.value); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); input.blur(); } });
    input.addEventListener('focus', function () { input.select(); });
  });

  /* Drawer */
  var lastFocus = null;
  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.body.classList.add('nh-lock');
    var closeBtn = drawer.querySelector('.nh-drawer__close');
    if (closeBtn) closeBtn.focus();
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden || drawer.hasAttribute('data-static')) return;
    drawer.hidden = true;
    document.body.classList.remove('nh-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-order]')) { e.preventDefault(); openDrawer(); }
    else if (e.target.closest('[data-close-order]')) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  if (linesEl) {
    linesEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-line-key]');
      if (!b) return;
      var key = b.getAttribute('data-line-key');
      var q = parseInt(b.getAttribute('data-to'), 10);
      b.disabled = true;
      api('/cart/change.js', { id: key, quantity: q })
        .then(function (c) { cart = c; render(); say(tr('orderUpdated')); })
        .catch(function (err) { say(tr('updateFailed') + err.message); load(); });
    });
  }

  if (noteEl) {
    noteEl.addEventListener('change', function () {
      api('/cart/update.js', { note: noteEl.value }).then(function (c) { cart = c; say(tr('noteSaved')); }).catch(function () {});
    });
  }

  /* Delivery or pickup (venues in Norway) */
  function syncModeInputs() {
    if (!modeEl) return;
    Array.prototype.forEach.call(modeEl.querySelectorAll('input[name="nh-mode"]'), function (r) { r.checked = (r.value === mode); });
    Array.prototype.forEach.call(modeEl.querySelectorAll('[data-mode-set]'), function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-mode-set') === mode ? 'true' : 'false');
    });
  }
  // Switch between delivery and pickup, and save the choice on the cart ("Delivery choice").
  function setMode(next) {
    mode = next === 'pickup' ? 'pickup' : 'delivery';
    syncModeInputs();
    syncWhenText();
    render();
    var attrs = {};
    attrs[MODE_KEY] = MODE_LABEL[mode];
    return api('/cart/update.js', { attributes: attrs })
      .then(function (c) { cart = c; say(mode === 'pickup' ? tr('pickupSelected') : tr('deliverySelected')); })
      .catch(function () {});
  }
  if (modeEl) {
    modeEl.addEventListener('change', function (e) {
      var r = e.target;
      if (!r || r.name !== 'nh-mode') return;
      setMode(r.value);
    });
    modeEl.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-mode-set]');
      if (!b) return;
      e.preventDefault();
      setMode(b.getAttribute('data-mode-set'));
    });
  }

  /* Delivery day (Thursdays) and repeat */
  var DATE_KEY = 'Delivery date';
  var REPEAT_KEY = 'Repeat';
  var DAY = 86400000;
  // Today in Oslo as a day number, with its weekday and the hour there.
  function osloNow() {
    var parts = {};
    try {
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Oslo', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' })
        .formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    } catch (e) {
      var d = new Date();
      parts = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate(), hour: d.getHours() };
    }
    var day = Math.round(Date.UTC(+parts.year, +parts.month - 1, +parts.day) / DAY);
    return { day: day, wd: new Date(day * DAY).getUTCDay(), hour: (+parts.hour) % 24 };
  }
  // Days without deliveries: Norwegian public holidays (red days), Christmas Eve and New Year's Eve.
  // Easter Sunday by the Gregorian computus; the movable holidays follow from it.
  function easterDay(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31), date = ((h + l - 7 * m + 114) % 31) + 1;
    return Math.round(Date.UTC(y, month - 1, date) / DAY);
  }
  var closedYears = {};
  function isClosed(day) {
    var y = new Date(day * DAY).getUTCFullYear();
    if (!closedYears[y]) {
      var set = {}, e = easterDay(y);
      // Maundy Thursday, Good Friday, Easter Sunday and Monday, Ascension Day, Whit Sunday and Monday
      [-3, -2, 0, 1, 39, 49, 50].forEach(function (o) { set[e + o] = true; });
      // New Year's Day, 1 May, 17 May, Christmas Eve, Christmas Day, Boxing Day, New Year's Eve
      [[1, 1], [5, 1], [5, 17], [12, 24], [12, 25], [12, 26], [12, 31]].forEach(function (md) {
        set[Math.round(Date.UTC(y, md[0] - 1, md[1]) / DAY)] = true;
      });
      closedYears[y] = set;
    }
    return !!closedYears[y][day];
  }
  // Deliveries are on Thursdays. On a closed day the delivery moves a day earlier (again if that day is closed too).
  function deliveryDay(thursday) {
    var d = thursday;
    while (isClosed(d)) d -= 1;
    return d;
  }
  // The next delivery days still open: an order must be in by 18:00 on the day before the delivery.
  function deliveryDays(n) {
    var now = osloNow();
    var t = now.day + ((4 - now.wd + 7) % 7);
    var out = [];
    for (var guard = 0; out.length < n && guard < n + 8; guard++, t += 7) {
      var d = deliveryDay(t), cut = d - 1;
      if (now.day < cut || (now.day === cut && now.hour < 18)) out.push(d);
    }
    return out;
  }
  function isoDay(day) { return new Date(day * DAY).toISOString().slice(0, 10); }
  var dayName = new Intl.DateTimeFormat(LOC, { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' });
  function dayLabel(iso) {
    var txt = dayName.format(new Date(iso + 'T00:00:00Z'));
    return txt.charAt(0).toUpperCase() + txt.slice(1);
  }

  function fillDates() {
    if (!dateSel) return;
    var current = dateSel.value || (cart && cart.attributes && cart.attributes[DATE_KEY]) || '';
    var days = deliveryDays(10).map(isoDay);
    dateSel.innerHTML = days.map(function (iso) { return '<option value="' + iso + '">' + esc(dayLabel(iso)) + '</option>'; }).join('');
    dateSel.value = days.indexOf(current) > -1 ? current : days[0];
  }
  function syncWhenText() {
    if (!whenLabel || !whenHelp) return;
    if (mode === 'pickup') {
      whenLabel.textContent = tr('whenPickup');
      whenHelp.textContent = tr('helpPickup');
    } else if (zone && (zone.key === 'posten' || zone.key === 'abroad' || zoneStatus().posten)) {
      whenLabel.textContent = tr('whenSend');
      whenHelp.textContent = tr('helpSend');
    } else {
      whenLabel.textContent = tr('whenDelivery');
      whenHelp.textContent = tr('helpDelivery');
    }
  }
  function saveWhen() {
    if (!dateSel) return;
    var attrs = {};
    attrs[DATE_KEY] = dateSel.value;
    attrs[REPEAT_KEY] = repeatSel ? repeatSel.value : 'No';
    api('/cart/update.js', { attributes: attrs })
      .then(function (c) { cart = c; say(tr('daySaved')); })
      .catch(function () {});
  }
  // Keep the saved day on the cart in step with the list (a day that has passed moves to the next open delivery day).
  function ensureWhen() {
    if (!dateSel || !cart || !cart.item_count) return;
    var a = cart.attributes || {};
    if (a[DATE_KEY] !== dateSel.value || (repeatSel && (a[REPEAT_KEY] || 'No') !== repeatSel.value)) saveWhen();
  }
  if (dateSel) dateSel.addEventListener('change', saveWhen);
  if (repeatSel) repeatSel.addEventListener('change', saveWhen);

  /* Top-up step: under the free-route minimum, show how much is missing before checkout */
  var topup = null;
  var topupDone = false;
  function needsTopUp() {
    if (abroad || mode !== 'delivery' || !zone || !zone.minEx) return false;
    var st = zoneStatus();
    return !!st.posten && st.short > 0;
  }
  function dayInline() {
    var iso = dateSel && dateSel.value;
    if (!iso) return tr('nextThursday');
    var txt = dayName.format(new Date(iso + 'T00:00:00Z'));
    return NB ? txt.toLowerCase() : txt;
  }
  function buildTopUp() {
    var host = (drawer && drawer.closest('.nho')) || document.body;
    topup = document.createElement('div');
    topup.className = 'nho-topup';
    topup.hidden = true;
    topup.innerHTML =
      '<div class="nho-topup__card" role="dialog" aria-modal="true" aria-labelledby="nho-topup-title">' +
        '<p class="nho-topup__title" id="nho-topup-title" data-top-title></p>' +
        '<p class="nho-topup__text" data-top-text></p>' +
        '<div class="nh-progress" aria-hidden="true"><i data-top-bar></i></div>' +
        '<p class="nho-topup__meta" data-top-meta></p>' +
        '<div class="nho-topup__btns">' +
          '<button type="button" class="nho-topup__go" data-top-add>' + esc(tr('topAdd')) + '</button>' +
          '<button type="button" class="nho-topup__alt" data-top-paynow>' + esc(tr('topPayNow')) + '</button>' +
        '</div>' +
      '</div>';
    host.appendChild(topup);
    topup.addEventListener('click', function (e) {
      if (e.target === topup) { closeTopUp(); return; }
      if (e.target.closest('[data-top-add]')) {
        closeTopUp();
        var list = document.querySelector('.nho .list') || document.getElementById('nh-range');
        if (list) list.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else if (e.target.closest('[data-top-paynow]')) {
        closeTopUp(true);
        if (checkoutBtn) location.href = checkoutBtn.href;
      }
    });
  }
  function openTopUp() {
    if (!topup) buildTopUp();
    var st = zoneStatus();
    var short = krWhole(st.short), min = krWhole(zone.minEx);
    topup.querySelector('[data-top-title]').textContent = tr('topTitle', { short: short });
    topup.querySelector('[data-top-text]').textContent = tr('topText', { short: short, min: min, day: dayInline() });
    topup.querySelector('[data-top-bar]').style.width = Math.min(100, Math.round((st.ex / zone.minEx) * 100)) + '%';
    topup.querySelector('[data-top-meta]').textContent = tr('topMeta', { now: krWhole(st.ex), min: min });
    topup.hidden = false;
    var first = topup.querySelector('[data-top-add]');
    if (first) first.focus();
  }
  function closeTopUp(leaving) {
    if (!topup || topup.hidden) return;
    topup.hidden = true;
    if (!leaving && (sendBtn || checkoutBtn)) (sendBtn || checkoutBtn).focus();
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeTopUp(); });

  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function (e) {
      var st = zoneStatus();
      if (!cart || !cart.item_count || !st.ok) { e.preventDefault(); }
    });
  }

  /* Send bestilling: the order goes straight to us, delivered and invoiced, with no checkout page */
  var PROXY = '/apps/barback';
  var sendKey = '';
  var sending = false;
  function setTip(text, warn) {
    if (!tipEl) return;
    tipEl.textContent = text;
    tipEl.classList.toggle('is-warn', !!warn);
  }
  function sendError(code, data) {
    var map = {
      login: 'errLogin', not_venue: 'errLogin', abroad: 'errAbroad', product: 'errProduct',
      empty: 'tipEmpty', too_heavy: 'errHeavy', below_min: 'errBelow'
    };
    var min = data && data.min ? krWhole(data.min * 100) : (zone && zone.minEx ? krWhole(zone.minEx) : '');
    setTip(tr(map[code] || 'errGeneric', { min: min }), true);
  }
  function showSent(res) {
    var day = res.date ? dayName.format(new Date(res.date + 'T00:00:00Z')) : tr('nextThursday');
    if (NB && res.date) day = day.toLowerCase();
    var how = res.shipping === 'Posten' ? tr('sentPosten', { day: day }) : tr('sentRoute', { day: day });
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var box = document.createElement('div');
    box.className = 'nho-sent';
    box.setAttribute('role', 'status');
    box.innerHTML =
      '<p class="eyebrow">' + esc(tr('sentEyebrow')) + '</p>' +
      '<p class="nho-sent__title">' + esc(tr('sentTitle', { order: res.order })) + '</p>' +
      '<p>' + esc(how) + '</p>' +
      '<p>' + esc(tr('sentInvoice')) + '</p>' +
      '<a class="checkout" href="' + esc(location.pathname + location.search) + '">' + esc(tr('sentNew')) + '</a>' +
      '<a class="nho-paynow" href="' + esc(root + 'account') + '">' + esc(tr('sentOrders')) + '</a>';
    Array.prototype.forEach.call(drawer.children, function (el) { el.hidden = true; });
    drawer.appendChild(box);
    if (drawer.scrollIntoView) drawer.scrollIntoView({ behavior: 'smooth', block: 'start' });
    say(tr('sentTitle', { order: res.order }));
  }
  function sendOrder() {
    if (sending || !cart || !cart.item_count) return;
    sending = true;
    if (!sendKey) sendKey = 'k' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
    sendBtn.classList.add('is-busy');
    sendBtn.textContent = tr('sending');
    setTip(tr('sending'), false);
    var lines = cart.items.map(function (it) { return { id: it.variant_id, q: it.quantity }; });
    fetch(PROXY + '/pass', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (pass) {
        return fetch(PROXY + '/send-order', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            pass: pass, lines: lines, key: sendKey,
            date: dateSel ? dateSel.value : '',
            repeat: repeatSel ? repeatSel.value : 'No',
            note: noteEl ? noteEl.value : (cart.note || '')
          })
        });
      })
      .then(function (r) { return r.json().catch(function () { return { ok: false, code: 'shop_error' }; }); })
      .then(function (res) {
        if (res && res.ok) {
          sendKey = '';
          return api('/cart/clear.js', {}).catch(function () {}).then(function () { showSent(res); });
        }
        sendError(res && res.code, res);
      })
      .catch(function () { sendError('shop_error'); })
      .then(function () {
        sending = false;
        sendBtn.classList.remove('is-busy');
        sendBtn.textContent = tr('sendLabel');
      });
  }
  if (sendBtn) {
    sendBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (!cart || !cart.item_count) return;
      if (needsTopUp()) { openTopUp(); return; }
      sendOrder();
    });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function render() {
    if (!cart) return;
    // Cards
    cards.forEach(function (c) {
      var v = c.getAttribute('data-variant');
      if (pending[v] == null) setCard(c, qtyInCart(v));
    });
    // Counts
    Array.prototype.forEach.call(countEls, function (el) { el.textContent = cart.item_count; });

    var st = zoneStatus();
    var exLabel = abroad ? '' : ' ' + tr('exclMva');

    // Order form: the total in the summary card
    Array.prototype.forEach.call(document.querySelectorAll('[data-order-total]'), function (el) { el.textContent = kr(st.ex); });

    // Mobile order bar
    if (orderbar) {
      orderbar.hidden = !cart.item_count;
      if (orderbarText) orderbarText.textContent = cart.item_count + ' ' + (cart.item_count === 1 ? tr('unit') : tr('units')) + ', ' + kr(st.ex) + exLabel;
    }

    // Drawer lines
    if (linesEl) {
      if (!cart.items.length) {
        linesEl.innerHTML = '<p class="nh-empty">' + esc(tr('empty')) + '</p>';
      } else {
        linesEl.innerHTML = cart.items.map(function (it) {
          var info = products[String(it.variant_id)] || {};
          var img = it.image || info.image || '';
          var unitName = info.unit || (it.variant_title || '');
          var each = abroad ? it.final_price : exOf(it.final_price);
          var line = abroad ? it.final_line_price : exOf(it.final_line_price);
          var stop = abroad && info.norwayOnly;
          return '<div class="nh-line-item' + (stop ? ' is-blocked' : '') + '">' +
            (img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" width="56" height="56" loading="lazy">' : '<span></span>') +
            '<div><div class="nh-line-item__name">' + esc(it.product_title) + '</div>' +
            '<div class="nh-line-item__meta">' + esc(unitName) + ' &middot; ' + kr(each) + ' ' + esc(tr('each')) + esc(exLabel) + '</div>' +
            (stop ? '<div class="nh-line-item__warn">' + esc(tr('soldNorway')) + '</div>' : '') + '</div>' +
            '<div class="nh-line-item__right"><span class="nh-line-item__price">' + kr(line) + '</span>' +
            '<div class="nh-mini-qty" role="group" aria-label="' + esc(tr('qtyOf', { name: it.product_title })) + '">' +
            '<button type="button" data-line-key="' + esc(it.key) + '" data-to="' + (it.quantity - 1) + '" aria-label="' + esc(tr('oneLess')) + '">&minus;</button>' +
            '<span>' + it.quantity + '</span>' +
            (stop ? '<button type="button" disabled aria-label="' + esc(tr('notAbroad')) + '">+</button>'
                  : '<button type="button" data-line-key="' + esc(it.key) + '" data-to="' + (it.quantity + 1) + '" aria-label="' + esc(tr('oneMore')) + '">+</button>') +
            '</div></div></div>';
        }).join('');
      }
    }

    // Delivery box
    if (zoneBox) {
      var html, cls = '';
      if (abroad) {
        var place = [D.city, D.countryName || D.country].filter(Boolean).join(', ');
        html = '<strong>' + esc(place ? tr('deliveryTo', { place: place }) : tr('deliveryPlain')) + '</strong>' +
          esc(tr('postenWeight')) + ' ' + esc(tr('importVat'));
        cls = 'is-ok';
        if (st.blocked) {
          html += '<p class="nh-drawer__warn">' + esc(tr('sjRemove')) + '</p>';
          cls = 'is-short';
        }
        if (cart.items.length && !exportApplied()) {
          html += '<p class="nh-drawer__warn">' + esc(tr('exportHelp')) + '</p>';
          cls = 'is-short';
        }
      } else if (mode === 'pickup') {
        html = '<strong>' + esc(tr('pickupTitle')) + '</strong>' + esc(tr('pickupLine'));
        cls = 'is-ok';
      } else if (!zone) {
        html = '<strong>' + esc(tr('deliveryTitle')) + '</strong>' + esc(tr('noPostcode'));
      } else if (zone.key === 'posten') {
        html = '<strong>' + esc(tr('deliveryTo', { place: (D.zip + ' ' + (D.city || '')).trim() })) + '</strong>' + esc(tr('postenNoMin'));
        cls = 'is-ok';
      } else {
        var pct = Math.min(100, Math.round((st.ex / zone.minEx) * 100));
        if (!st.posten) {
          html = '<strong>' + esc(tr('freeWeekly', { zone: zone.label })) + '</strong>' + esc(tr('overMin', { min: krWhole(zone.minEx) }));
        } else {
          html = '<strong>' + esc(tr('deliveryTo', { place: (D.zip + ' ' + (D.city || '')).trim() })) + '</strong>' + esc(tr('shortMin', { short: kr(st.short), min: krWhole(zone.minEx) }));
        }
        cls = 'is-ok';
        html += '<div class="nh-progress" aria-hidden="true"><i style="width:' + pct + '%"></i></div>';
      }
      zoneBox.className = 'nh-drawer__zone ' + cls;
      zoneBox.innerHTML = html;
    }

    // Totals
    if (sumEl) {
      if (abroad) {
        sumEl.innerHTML =
          '<dt class="nh-sum__lead">' + esc(exportApplied() ? tr('sumNoMva') : tr('sumTotal')) + '</dt><dd class="nh-sum__lead">' + kr(cart.total_price) + '</dd>' +
          '<dt>' + esc(tr('sumShipping')) + '</dt><dd>' + esc(tr('sumAtCheckout')) + '</dd>';
      } else {
        var inc = cart.total_price;
        var ex = exOf(inc);
        sumEl.innerHTML =
          '<dt class="nh-sum__lead">' + esc(tr('sumExcl')) + '</dt><dd class="nh-sum__lead">' + kr(ex) + '</dd>' +
          '<dt>' + esc(tr('sumMva')) + '</dt><dd>' + kr(inc - ex) + '</dd>' +
          '<dt>' + esc(tr('sumIncl')) + '</dt><dd>' + kr(inc) + '</dd>' +
          '<dt>' + esc(tr('sumDelivery')) + '</dt><dd>' + esc(mode === 'pickup' ? tr('sumFreePickup') : (zone && zone.key !== 'posten' && !st.posten ? tr('sumFree') : (sendBtn && zone && zone.key === 'posten' ? tr('sumOnInvoice') : tr('sumAtCheckout')))) + '</dd>';
      }
    }

    // Checkout button and tip
    if (checkoutBtn) {
      var canGo = cart.item_count > 0 && st.ok;
      checkoutBtn.setAttribute('aria-disabled', canGo ? 'false' : 'true');
      if (tipEl) {
        if (!cart.item_count) {
          tipEl.textContent = tr('tipEmpty');
        } else if (abroad) {
          tipEl.textContent = st.blocked ? tr('tipRemoveSj') : tr('tipAbroad', { cur: curCode() });
        } else if (!st.ok) {
          tipEl.textContent = tr('tipShort');
        } else if (sendBtn) {
          if (!sending) {
            if (zone && zone.key === 'posten') setTip(tr('tipSendPosten'), false);
            else if (st.posten) setTip(tr('tipSendShort', { min: krWhole(zone.minEx) }), false);
            else setTip(tr('tipSendRoute'), false);
          }
        } else {
          var method = mode === 'pickup' ? PICKUP.method : (st.posten ? ZONES.posten.method : (zone ? zone.method : ''));
          tipEl.textContent = (method ? tr('tipChoose', { m: method }) : '') + tr('tipPay');
        }
      }
    }
    if (sendBtn) sendBtn.setAttribute('aria-disabled', cart.item_count > 0 ? 'false' : 'true');
    if (noteEl && document.activeElement !== noteEl) noteEl.value = cart.note || '';
    if (whenEl) whenEl.hidden = !cart.item_count;
    syncWhenText();
  }

  // Account strip: delivery line
  if (zoneLine) {
    if (abroad) {
      zoneLine.textContent = tr('lineAbroad');
    } else if (!zone) {
      zoneLine.textContent = tr('lineNoZone');
    } else if (zone.key === 'posten') {
      zoneLine.textContent = tr('linePosten');
    } else {
      zoneLine.textContent = tr('lineRoute', { zone: zone.label, min: krWhole(zone.minEx) });
    }
  }

  function load() {
    return api('/cart.js').then(function (c) { cart = c; render(); }).catch(function () { say(tr('loadFailed')); });
  }

  load().then(function () {
    if (!abroad && modeEl && cart && cart.attributes && cart.attributes[MODE_KEY] === MODE_LABEL.pickup) { mode = 'pickup'; render(); }
    syncModeInputs();
    if (repeatSel && cart && cart.attributes && cart.attributes[REPEAT_KEY]) repeatSel.value = cart.attributes[REPEAT_KEY];
    fillDates();
    syncWhenText();
    ensureWhen();
    if (/[?&]cart=open\b/.test(location.search)) openDrawer();
  });
})();
